module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_WoodMatted_MockedUp.96a13aa6.jpg";